import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SoilAnalysisState } from '../models/soil-analysis.models';

export const selectDefaultSoilAnalysisState =
  createFeatureSelector<SoilAnalysisState>('soilAnalysis');

export const selectDefaultSoilAnalyses = createSelector(
  selectDefaultSoilAnalysisState,
  (state) => state.defaultSoilAnalyses ?? [],
);
